import { 
    ARTISAN_PRODUCT_CREATE_FAIL,
    ARTISAN_PRODUCT_CREATE_REQUEST,
    ARTISAN_PRODUCT_CREATE_RESET,
    ARTISAN_PRODUCT_CREATE_SUCCESS,
    ARTISAN_PRODUCT_DELETE_FAIL,
    ARTISAN_PRODUCT_DELETE_REQUEST,
    ARTISAN_PRODUCT_DELETE_SUCCESS,
    ARTISAN_PRODUCT_DETAILS_FAIL,
    ARTISAN_PRODUCT_DETAILS_REQUEST,
    ARTISAN_PRODUCT_DETAILS_SUCCESS,
    ARTISAN_PRODUCT_LIST_FAIL, 
    ARTISAN_PRODUCT_LIST_REQUEST, 
    ARTISAN_PRODUCT_LIST_SUCCESS 
} from "../constants/ArtisanConstants";

export const artisanProductListReducer = (state = { products: [] }, { type, payload }) => {

    switch (type) {
        case ARTISAN_PRODUCT_LIST_REQUEST:
            return {
                loading: true,
                products: []
            }
        case ARTISAN_PRODUCT_LIST_SUCCESS:
            return {
                loading: false,
                products: payload
            }
        case ARTISAN_PRODUCT_LIST_FAIL:
            return {
                loading: false,
                error: payload
            }
        default:
            return state;
    }
}


export const artisanProductDetailsReducer = (state = { product: {} }, { type, payload }) => {

    switch (type) {
        case ARTISAN_PRODUCT_DETAILS_REQUEST:
            return {
                loading: true,
                product: {}
            }
        case ARTISAN_PRODUCT_DETAILS_SUCCESS:
            return {
                loading: false,
                product: payload
            }
        case ARTISAN_PRODUCT_DETAILS_FAIL:
            return {
                loading: false,
                error: payload
            }
        default:
            return state;
    }
}



export const artisanProductDeleteReducer = (state = {}, { type, payload }) => {

    switch (type) {
        case ARTISAN_PRODUCT_DELETE_REQUEST:
            return {
                loading: true
            }

        case ARTISAN_PRODUCT_DELETE_SUCCESS:
            return {
                loading: false,
                success: true
            }

        case ARTISAN_PRODUCT_DELETE_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}



export const artisanProductCreateReducer = (state = {}, { type, payload }) => {

    switch (type) {
        case ARTISAN_PRODUCT_CREATE_REQUEST:
            return {
                loading: true,
                ...state
            }

        case ARTISAN_PRODUCT_CREATE_SUCCESS:
            return {
                loading: false,
                success: true,
                product: payload
            }

        case ARTISAN_PRODUCT_CREATE_FAIL:
            return {
                loading: false,
                error: payload
            }
        case ARTISAN_PRODUCT_CREATE_RESET:
            return {}

        default:
            return state;
    }
}